import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { map, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  public constructor(private readonly authService: AuthService, private readonly router: Router) {}

  public canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      tap((user) => {
        if (!user) {
          const pathInfo: Location = { ...location };
          sessionStorage.setItem('redirectUrlInAuth', pathInfo.pathname);
          if (pathInfo.search?.length) {
            sessionStorage.setItem('redirectQueryParamAuth', pathInfo.search.slice(1));
          }
          this.router.navigate(['/login']).catch(console.error);
        } else {
          this.authService.setUser(user);
        }
      }),
      map((user) => !!user)
    );
  }
}
